import FormElement from "./form-element";
import { EVENTS } from "../../../../js/constants";
import { scrollToElement } from "../../../../js/utils/helper/helper";
import FormElementFieldset from "./form-element--fieldset";

/**
 * Represents a Form including e.g. fieldsets, inputs, textarea, selects, buttons
 * all elements templates and stylings are defined by FSK
 * this class only takes care of validation
 */
class FormValidation {
  /**
   * @param {HTMLElement} element - form
   */
  constructor(element) {
    this.element = element;

    this.config = {
      formElements: [
        {
          selector: ".js-FormElement--fieldset",
          Class: FormElementFieldset,
        },
        {
          selector: "input, textarea, select",
          Class: FormElement,
        },
      ],
    };

    // set correct scope for callbacks
    this._onSubmit = this._onSubmit.bind(this);

    this._init();
  }

  /**
   * init
   *
   * @private
   */
  _init() {
    this._disableDefaultBrowserValidation();
    this._initFormElements();
    this._bind();
  }

  /**
   * disables custom browser validation and activates custom clientside form validation
   *
   * @private
   */
  _disableDefaultBrowserValidation() {
    this.element.setAttribute("novalidate", "novalidate");
  }

  /**
   * inits children form elements like input, textarea, select or custom form elements
   * [LayoutFieldset, FormElement, FormElement, ...]
   *
   * @private
   */
  _initFormElements() {
    this.formElements = [];

    this.config.formElements.forEach((formElement) => {
      const domElements = [
        ...this.element.querySelectorAll(formElement.selector),
      ];

      domElements.forEach((domElement) => {
        this.formElements.push(new formElement.Class(domElement));
      });
    });
  }

  /**
   * binds events
   *
   * @private
   */
  _bind() {
    this.element.addEventListener("submit", this._onSubmit);
  }

  /**
   * handles form submit
   *
   * @private
   * @param {object} event - submit event
   */
  _onSubmit(event) {
    const submitButton = event.submitter;
    if (submitButton && submitButton.hasAttribute("formnovalidate")) {
      return;
    }

    if (!this.formElements.every((formElement) => formElement.isValid())) {
      event.preventDefault();

      // validate inputs and set error message
      this.formElements.forEach((formElement) => {
        formElement.validate();
      });

      this._focusFirstError();
    } else {
      this.element.dispatchEvent(new CustomEvent(EVENTS.FORM_SUBMITTED));
    }
  }

  /**
   * focuses first form element with error state
   * it scrolls smoothly to that element based on the correct position
   * native focus scroll wouldn't consider the sticky header
   *
   * @private
   */
  _focusFirstError() {
    const { element } = this.formElements.find(
      (formElement) => !formElement.isValid()
    );

    element.focus({ preventScroll: true });

    scrollToElement(element);
  }
}

export default FormValidation;
